import AdminUpdatePasein from "../../components/AdminInvoice/InvoiceUpdate";

export default function UpdatePasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminUpdatePasein/>
    </div>
  );
}
